


export const SITECONST = {
    SERVICE_API_URL: 'https://hackathon.iotconnect.io'
}